module.exports = __webpack_public_path__ + "static/media/advantages_bar_middle_bottom.254b80ca.svg";